import { createFlagsScheme, schema } from '@funtech-int/yango-shared';

export const featureFlagsScheme = createFlagsScheme({
    isNewPlayerEnabled: schema.boolean.optional(false),
    isNewBackgroundPlayerEnabled: schema.boolean.optional(false),
    isCrunchyrollPageEnabled: schema.boolean.optional(false),
});
